import { render, staticRenderFns } from "./AboutSearch.vue?vue&type=template&id=3a009803&"
import script from "./AboutSearch.vue?vue&type=script&lang=js&"
export * from "./AboutSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports